document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.variant-picker__option-values');
  if (!track) return;

  // Only for mobile
  if (window.innerWidth > 768) return;

  // Make container relative
  track.parentElement.style.position = 'relative';

  // Create arrows
  const prev = document.createElement('button');
  prev.className = 'variant-slider-arrow prev';
  prev.innerHTML = '&#10094;';
  const next = document.createElement('button');
  next.className = 'variant-slider-arrow next';
  next.innerHTML = '&#10095;';

  // Insert into DOM
  track.parentElement.appendChild(prev);
  track.parentElement.appendChild(next);

  // Scroll function
  const scrollAmount = 80; // px per click
  prev.addEventListener('click', () => {
    track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  });
  next.addEventListener('click', () => {
    track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  });
});